module.exports = __webpack_public_path__ + "static/media/copy.106c1d21.svg";